import { Modal } from "antd";

const showLogoutConfirmation = ({ type, title, content, onConfirm }) => {
  Modal[type]({
    title: title,
    content: content,
    okText: "Ok",
    onOk: onConfirm,
  });
};

export default showLogoutConfirmation;
